(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusController', CampusController);

    CampusController.$inject = ['Campus'];

    function CampusController(Campus) {

        var vm = this;

        vm.campuses = [];

        loadAll();

        function loadAll() {
            Campus.query(function(result) {
                vm.campuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();
